// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e6d4","textarea":"styles_textarea__2C2vr"};